export class Carrier {
    id: number;
    name: string;
    icon?: string;
}
